import { render } from "./LoginPrepare.vue?vue&type=template&id=70c24750&scoped=true"
import script from "./LoginPrepare.vue?vue&type=script&lang=js"
export * from "./LoginPrepare.vue?vue&type=script&lang=js"

import "./LoginPrepare.vue?vue&type=style&index=0&id=70c24750&scoped=true&lang=css"

import exportComponent from "D:\\eazyc\\ezDev\\ECS-Cognitive\\cognitive-screening-mobile-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70c24750"]])

export default __exports__